// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"LoadingSpinner__loadingSpinner--4ulksS","rotate":"LoadingSpinner__rotate--KjrOmd"};